import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { HoldingItem } from '@core/models/holding/holding-item.model';
import { GeneralInformationService } from '@core/services/assets-S3/general-information.service';

@Component({
  selector: 'app-tp-about-silvio-santos-holding',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tp-about-silvio-santos-holding.component.html',
  styleUrl: './tp-about-silvio-santos-holding.component.scss',
})
export class TpAboutSilvioSantosHoldingComponent {
  @Input() isMobile = false;

  holding!: HoldingItem;
  groupCompanies!: HoldingItem[];

  constructor(private generalInfoService: GeneralInformationService) {
    this.getGroupCompanies();
  }

  getGroupCompanies() {
    this.generalInfoService
      .getGroupSilvioSantosDetails()
      .subscribe(response => {
        this.holding = response.holding;
        this.groupCompanies = response.companies;
      });
  }
}
